module.exports = __webpack_public_path__ + "img/login_logo.48e30302.png";